import { Component, OnInit, ViewChild, Input, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { SolicitacaoService } from 'src/app/service/solicitacao/solicitacao.service';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  ERRO_DADOS_NAO_GRAVADOS, MSG_LIMITE_DESCRICAO, MSG_OBG_ASSUNTO, MSG_OBG_CARTORIO, MSG_OBG_CLASSIFICACAO,
  MSG_OBG_DESCRICAO, MSG_OBG_MUNICIPIO, MSG_OBG_TIPO_JUSTICA, OK_MANIFESTO_ENVIADO, MSG_OBG_NUM_PROCESSO, MSG_OBG_NUM_PROCESSO_VALIDO, MSG_OBG_TEMA, MSG_OBG_EMAIL
} from './../../../tools/Mensagens';

@Component({
  selector: 'solicitacao',
  templateUrl: './solicitacao.component.html',
  styleUrls: ['./solicitacao.component.css']
})
export class SolicitacaoComponent implements OnInit {
  nome = this.authService.usuarioDTO.nome;
  email = this.authService.usuarioDTO.email;
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  alerts: String = '';
  isSolicitacaoRefatorada: boolean = true;
  modalRef: BsModalRef;
  camposNaoPreenchidos: String = "";

  constructor(
    public service: SolicitacaoService,
    private router: Router,
    public modalService: BsModalService,
    public authService: AuthService) { }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      this.service.solicitacao.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.solicitacao.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.solicitacao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.solicitacao.controls.listaCartorio.setValue(retorno.listaCartorio);
        this.service.solicitacao.controls.listaTipoProcessoCompleta.setValue(retorno.listaTipoProcessoCompleta);
        this.service.solicitacao.controls.listaSistemasCompleta.setValue(retorno.listaSistemasCompleta);
        this.service.solicitacao.controls.assuntos.setValue(retorno.assuntos);
      }
    });
  }

  onSubmit() {

    this.validarFormulario();

    if (this.service.solicitacao.value.assunto) {

      this.preencherDadosSolicitacao();

      if (this.alerts.length === 0) {
        this.service.enviar(this.service.solicitacao.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            //console.log('PAGINA_SUCESSO_FORM');
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            //console.log('ERRO_DADOS_NAO_GRAVADOS');
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      }
    }

  }

  preencherDadosSolicitacao() {
    this.service.solicitacao.value.nome = this.authService.usuarioDTO.nome;
    this.service.solicitacao.value.email = this.authService.usuarioDTO.email;

    if(!this.isSolicitacaoRefatorada){
      if (this.service.solicitacao.value.tipoDeJustica === '1' || this.service.solicitacao.value.tipoDeJustica === '2') {
        this.service.solicitacao.value.tipoDeJustica = this.service.solicitacao.value.tipoDeJustica;
      } else {
        this.service.solicitacao.value.tipoDeJustica = null;
      }
    }

    this.service.solicitacao.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.solicitacao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  zeraListaClassificacao() {
    this.service.solicitacao.value.listaClassificacao = [];
  }

  desmarcarCheckOutrosAssuntos() {
    this.service.solicitacao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.solicitacao.controls.tipoDeJustica.reset();
    this.service.solicitacao.controls.numeroProcesso.reset();
    this.service.solicitacao.controls.comarca.reset();
    this.service.solicitacao.controls.vara.reset();
    this.service.solicitacao.controls.numeroINFOPEN.reset();
    this.service.solicitacao.controls.descricaoSolicitacao.setValue('');
    this.service.solicitacao.controls.municipio.reset();
    this.service.solicitacao.controls.cartorio.reset();
    this.service.solicitacao.controls.localidade.reset();
    this.service.solicitacao.controls.listaTipoProcesso.reset();
    this.service.solicitacao.controls.listaSistemas.reset();
    this.service.solicitacao.controls.listaClassificacao.setValue([]);
    this.service.solicitacao.controls.assunto.reset();
    this.service.solicitacao.controls.files.reset();
    this.service.solicitacao.controls.numeroProcesso.disable();

    // this.service.reclamacao.controls.numeroProcesso.setValue('');
    // this.service.reclamacao.controls.tipoDeJustica.setValue('');
  }

  changeAssunto(item) {
    this.service.solicitacao.controls.assunto.setValue(item);

    // this.service.solicitacao.value.listaClassificacaoCompleta
    //   .map(item => item.selecionado = false);

    this.service.solicitacao.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.solicitacao.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    //this.resetFormControl();
  }

  resetFormControl() {
    this.service.solicitacao.controls.tipoDeJustica.reset();
    this.service.solicitacao.controls.localidade.reset();
    this.service.solicitacao.controls.descricaoSolicitacao.setValue('');
  }

  isAssuntoChecked(str) {
    return this.service.solicitacao.value.assunto &&
      this.service.solicitacao.value.assuntos
        .filter((assunto: any) => assunto.selected && assunto.value === str)
        .length > 0 ? true : false;
  }


  validarCampoDescricao() {

    this.alerts = '';

    if (this.service.solicitacao.value.descricaoSolicitacao === ''
      || this.service.solicitacao.value.descricaoSolicitacao == null) {
      this.alerts = this.alerts + MSG_OBG_DESCRICAO;

    } else if (this.service.solicitacao.value.descricaoSolicitacao.length < 0
      && this.service.solicitacao.value.descricaoSolicitacao.length > 5000) {
      this.alerts = this.alerts + MSG_LIMITE_DESCRICAO;
    }

    if (this.alerts.length > 0) {
      alert(this.alerts);
    }

  }

  validarFormulario() {

    this.alerts = '';

    if (this.service.solicitacao.value.assunto == null || this.service.solicitacao.value.assunto === '') {
      this.alerts = this.alerts + MSG_OBG_TEMA;
    }
    if (this.service.solicitacao.value.descricaoSolicitacao === ''
        || this.service.solicitacao.value.descricaoSolicitacao == null) {
        this.alerts = this.alerts + MSG_OBG_DESCRICAO;
    } else if (this.service.solicitacao.value.descricaoSolicitacao.length < 0
        && this.service.solicitacao.value.descricaoSolicitacao.length > 5000) {
        this.alerts = this.alerts + MSG_LIMITE_DESCRICAO;
    }

    if( this.service.solicitacao.value.email === '' || this.service.solicitacao.value.email == null){
      this.alerts = this.alerts + MSG_OBG_EMAIL;
    }

    if (this.alerts.length > 0) {
      alert(this.alerts);
    }
  }

}
